import React from 'react'

interface CheckProps {
  size?: number
  color?: string
}

export const Check: React.FC<CheckProps> = ({
  size = 20,
  color = '#32E970',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 6L7.75 14L4 10.3636"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
